/**
 * Catalog ids (apps/apolloserver/src/access/catalog.ts) that apps/web checks for access levels.
 * Renaming or removing such a node in the catalog: update this file.
 */
export const SUPPLIERS_ACCESS_NODE = 'suppliers';
